import { IStyle, Stack } from '@fluentui/react';
import { CommonStyles, FontWeights, IconName } from '@h2oai/ui-kit';
import React from 'react';

import { LabelIconTooltip } from '../AIEnginesPage/components/LabelIconTooltip/LabelIconTooltip';
import Cell, { textCellStyles } from './Cell';

export interface MetadataCellContentsProps {
  title?: string;
  metadata?: (string | React.ReactNode)[];
  children?: React.ReactNode;
  tooltip?: string;
}

const stackStyles = {
  root: {
    width: '100%',
    '.meta-data-cell-value': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
  },
};

export const baseMetadataTextStyles = {
  ...textCellStyles,
  ...CommonStyles.truncateString,
  color: 'unset',
};

export const metadataTextStyles = {
  ...baseMetadataTextStyles,
  width: 'calc(100% - 10px)',
} as IStyle;

export function MetadataCellContents(props: MetadataCellContentsProps) {
  const titleTooltip = typeof props.children === 'string' ? props.children : undefined;

  return (
    <Stack styles={stackStyles} tokens={{ childrenGap: 4 }} className="metadata-cell-contents" title={titleTooltip}>
      <Stack horizontal>
        {props.title && <span style={{ fontWeight: FontWeights.bold, marginBottom: 4 }}>{props.title}</span>}
        <LabelIconTooltip iconName={IconName.Info} tooltip={props.tooltip} />
      </Stack>
      {props.metadata &&
        props.metadata.map((datum, i) => (
          <span
            key={typeof datum === 'string' ? datum : i}
            style={metadataTextStyles as React.CSSProperties}
            title={typeof datum === 'string' ? datum : undefined}
          >
            {datum}
          </span>
        ))}
      <div className="meta-data-cell-value">{props.children}</div>
    </Stack>
  );
}

export function MetadataCell(props: MetadataCellContentsProps) {
  return (
    <Cell>
      <MetadataCellContents {...props} />
    </Cell>
  );
}
